<template>
    <div class="detail-wrap" id="caseDetailPages">
        <div class="logo-img">
            <img src="../../../../assets/images/other/logo.png" alt="">
        </div>
        <div class="head-img">
            <img :src="sBuildImg" alt="">
        </div>
        <div class="info-wrap">
            <div class="title">A.O.史密斯商用净水优质应用案例</div>
            <div class="name">{{objInfo.title}}</div>
            <template v-for="it in arrInfo">
                <div class="info-item">
                    <div class="label">
                        <div class="box">
                            <img src="../../../../assets/images/other/dian.png" alt="">
                            <span>{{it.name}}：</span>
                        </div>
                    </div>
                    <div class="value">{{it.value}}</div>
                </div>
            </template>
            <div class="tips">·安全·便捷·低塑·</div>
            <div class="qr-img">
                <img :src="wxQrCode" alt="">
                <span>扫码查看详情</span>
            </div>
        </div>
    </div>
</template>

<script>
import oRequest from "@/libsV2/request";
import html2canvas from "html2canvas";

export default {
    name: "info",
    data(){
        return {
            objInfo:{
                feedback:'',
                advantage:''
            },//案例详情
            arrInfo: [
                { id: 1, name: '所属城市', value: '', icon: 'icon01.png',key:'city_name',isShow:true },
                { id: 2, name: '行业类别', value: '', icon: 'icon02.png',key:'industry_name',isShow:true },
                { id: 3, name: '服务人数', value: '', icon: 'icon03.png' ,key:'people_served_count_name',isShow:true },
            ],
            arrImg:[],
            arrGoods:[],
            arrWterType:[],
            wxQrCode:'',
            sBuildImg:'',
        }
    },
    mounted() {
        this.$store.commit('loadSwitch',true)
        const data = this.$route.query.info || JSON.stringify({
            user_id: 491,
            topic_id: 196,
            type: 'draft_id',
        });
        const _data = JSON.parse(data);
        $init(() => {
            this.sBuildImg =this.$route.query.sBuildImg
            oRequest.getData('bus/topic/index/getConfig').then(res => {
                this.arrWterType=res.data.data.result.water_type
                oRequest.getData('bus/topic/index/topic', _data).then(res => {
                    const {data: {data: {result}}} = res;
                    this.arrGoods=result.goods
                    this.objInfo=result
                    this.arrInfo.forEach(it=>{
                        it.value=result[it.key]
                        if(it.key=='industry_name') {
                            it.value = result[it.key].join(',')
                        }
                        if(it.key=='city_name') {
                            it.value =(result.province_name==result.city_name) ? result.city_name :  result.province_name+result.city_name
                        }
                    })
                    oRequest.getData('/comm/qrcode/get', {
                        type: 1,
                        is_hyaline:1,
                        // version:'trial',// 生成体验版码
                        page: 'subcontract/pages/business/case/detailv2/detail',
                        param:`user_id=${_data.user_id}&id=${_data.topic_id}&topicid=${_data.topic_id}&scource=xcx&track_action=bus_topic_share&track_id=${_data.topic_id}&track_uuid=${this.$route.query.track_uuid}&type=bus_id`
                    }).then((res) => {
                        this.$store.commit('loadSwitch',false)
                        const {data: {data: {result:{url}}}} = res;
                        this.wxQrCode = url;
                        const timer = setTimeout(() => {
                            html2canvas(document.querySelector("#caseDetailPages"), {
                                useCORS: true,
                            }).then(c => {
                                console.log(c.toDataURL(),'图片')
                                wx.miniProgram.postMessage({data: {base64: c.toDataURL()}});
                                wx.miniProgram.navigateBack();
                            });
                            clearTimeout(timer);
                        }, 1500);
                    });


                });
            })
        })
    }
}
</script>

<style scoped lang="scss">
.detail-wrap{
    width: 100%;
    padding-top: 55px;
    .logo-img{
        width: 100%;
        display: flex;
        justify-content: center;
        img{
            width: 302px;
        }
    }
    .head-img{
        padding: 0 22px;
        margin-top: 30px;
        img{
            width: 100%;
        }
    }
    .info-wrap{
        padding: 58px 66px 48px;
        position: relative;
        .title{
            font-size: 30px;
            font-weight: normal;
            color: #595757;
            line-height: 48px;
        }
        .name{
            font-size: 38px;
            font-weight: 600;
            color: #595757;
            margin-bottom: 30px;
            max-width: 460px;
        }
        .info-item{
            display: flex;
            margin-bottom: 10px;
            .label{
                white-space: nowrap;
                font-size: 28px;
                color: #595757;
                font-weight: 600;
                display: flex;
                .box{
                    img{
                        vertical-align: middle;
                        width: 10px;
                        margin-right: 10px;
                        height: 10px;
                        transform: translateY(-4px);
                    }
                }

            }
            .value{
                font-size: 28px;
                color: #595757;
                max-width: 300px;
            }
        }
        .tips{
            font-size: 30px;
            color: #A3A3A3;
            line-height: 48px;
            margin-top: 42px;
            text-align: center;
        }
        .qr-img{
            width: 170px;
            position: absolute;
            right: 66px;
            top: 100px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img{
                width: 100%;
            }
            span{
                font-size: 23px;
                margin-top: 4px;
                color: #A3A3A3;
            }
        }
    }
}
</style>
